import operatorApiFetch from './apiService';

export const merchantShippingTypesService = {
  // 已安裝清單
  index: async (merchantId) => {
    try {
      const response = await operatorApiFetch(`merchant_shipping_types?merchant_id=${merchantId}`);
      if (!response.ok) throw new Error('Failed to fetch merchant shipping types');
      const data = await response.json();
      return { success: true, data: data.data };
    } catch (error) {
      console.error(error);
      return { success: false, error: error.message };
    }
  },

  // 安裝
  create: async (params) => {
    try {
      const response = await operatorApiFetch('merchant_shipping_types', {
        method: 'POST',
        body: JSON.stringify(params),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to install shipping type');
      }
      const data = await response.json();
      return { success: true, data: data.data };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // 編輯
  update: async (id, params) => {
    try {
      const response = await operatorApiFetch(`merchant_shipping_types/${id}`, {
        method: 'PUT',
        body: JSON.stringify(params),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to update merchant shipping type');
      }
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // 移除
  destroy: async (id) => {
    try {
      const response = await operatorApiFetch(`merchant_shipping_types/${id}`, {
        method: 'DELETE',
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to remove merchant shipping type');
      }
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },
};
